import { createContext } from 'react';

export default createContext({ character: 'cser', setCharacter() { }, highscore: 0, setHighscore() { }, });
